import { PointCloudStylingIntensity } from '@trimble/types';
import { POINT_CLOUD_INTENSITY_DEFAULTS } from '../point-cloud-intensity/point-cloud-intensity.model';

export const DEFAULT_RGB_GRADIENT_OFFSET = 0.5;

export interface PointCloudRgbControlProps
  extends Partial<PointCloudStylingIntensity> {
  onChange?(values: PointCloudStylingIntensity): void;
}

export const POINT_CLOUD_RGB_DEFAULTS: Required<PointCloudStylingIntensity> = {
  blendIntensity: false,
  gradient: POINT_CLOUD_INTENSITY_DEFAULTS,
};
